import React, { useEffect, useState } from "react";
import StaffShips from "./child/ShipDetails";
import StaffShipMainEngineDetails from "./child/MainEngineDetails";
import StaffAuxilaryEngine from "./child/AuxilaryEngineDetails";
import SubTabMachinary from "./child/SubTabMachinary";
import SubTabCargoMachinary from "./child/SubTabCargoMachinary";

function StaffEditShip() {
  const [ship_id, set_ship_id] = useState();
  const [activeTab, set_activeTab] = useState("ship");

  useEffect(() => {
    const user_data = JSON.parse(localStorage.getItem("user_data"));
    set_ship_id(parseInt(user_data?.data?.ship_details?.ship_id));
  }, []);

  useEffect(() => {
    const lastSelectedKey = localStorage.getItem("shiplogbook") || activeTab;
    set_activeTab(lastSelectedKey);
  }, []);

  const handleClick = (name) => {
    set_activeTab(name);
    localStorage.setItem("shiplogbook", name);
  };

  return (
    <>
      <div className="white-container">
        <ul className="marine-tabs">
          <li className={activeTab === "ship" ? "active" : ""} onClick={() => handleClick("ship")}>
            Ship Basic Details
          </li>
          <li className={activeTab === "main" ? "active" : ""} onClick={() => handleClick("main")}>
            Ship Main Engine
          </li>
          <li
            className={activeTab === "auxiliaryEngine" ? "active" : ""}
            onClick={() => handleClick("auxiliaryEngine")}
          >
            Ship Auxiliary Engine
          </li>
          <li
            className={activeTab === "auxiliaryMachinary" ? "active" : ""}
            onClick={() => handleClick("auxiliaryMachinary")}
          >
            Auxiliary Machinary
          </li>
          <li
            className={activeTab === "cargoMachinary" ? "active" : ""}
            onClick={() => handleClick("cargoMachinary")}
          >
            Cargo Machinary
          </li>
        </ul>
        <>
          {activeTab == "ship" && <StaffShips id={ship_id} />}
          {activeTab == "main" && <StaffShipMainEngineDetails id={ship_id} />}
          {activeTab == "auxiliaryEngine" && <StaffAuxilaryEngine id={ship_id} />}
          {activeTab == "auxiliaryMachinary" && <SubTabMachinary id={ship_id} />}
          {activeTab == "cargoMachinary" && <SubTabCargoMachinary id={ship_id} />}
        </>
      </div>
    </>
  );
}

export default StaffEditShip;
